import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export default function PlayCalendar(props) {
    return (
        <SvgIcon style={{ color: 'inherit', fill: 'currentColor' }} {...props}>
            <path d="M33.998,201.775C15.299,213.14,0,204.534,0,182.656V24.136C0,2.258,15.299-6.348,33.998,5.017 l127.835,77.711c18.695,11.368,18.692,29.969-0.003,41.337L33.998,201.775z" />
        </SvgIcon>
    );
}

PlayCalendar.defaultProps = {
    viewBox: '0 0 175.853 206.792'
};
